module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "image-toolbar__container"
  }, [_c('el-col', {
    staticClass: "image-toolbar__left-container",
    attrs: {
      "span": 1
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.onMenuClicked
    }
  }, [_c('i', {
    staticClass: "el-icon-menu"
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "image-toolbar__right-container",
    attrs: {
      "span": 1
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.onDownloadClicked
    }
  }, [_c('i', {
    staticClass: "el-icon-download"
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1b41000","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/image-filter/image-toolbar/image-toolbar.vue
// module id = 292
// module chunks = 0